import React from "react";

const Mcc = ({ className = "", justify = "center" }) => {
  // justify-ийн утгаас хамаарч class үүсгэнэ
  const justifyClass = `justify-content-${justify}`;
  const combinedClassName = `sectionTitle__small ${justifyClass} ${className}`;

  return (
    <span className={combinedClassName}>
      <i className="fa-solid fa-heart btn__icon"></i>
      МСС
    </span>
  );
};

export default Mcc;
